module.exports = __webpack_public_path__ + "static/media/_DSC6174.fa58aac2.jpg";